import React from 'react';
import { palette } from '../../../../utils/designTokens';

export default function ServiceChips({ participants = [] }) {
  if (participants.length <= 1) return null;
  const showEnv = new Set(participants.map(p => p.environment).filter(Boolean)).size > 1;
  return (
    <div className="flex items-center gap-1.5">
      {participants.map(p => {
        const label = showEnv && p.environment ? `${p.service_name} · ${p.environment}` : p.service_name;
        return (
          <span
            key={`${p.service_id}:${p.environment}`}
            className="px-2 py-0.5 rounded-full border text-xs"
            style={{
              color: palette.accents.primary.base,
              borderColor: palette.accents.primary.base,
              background: `${palette.accents.primary.base}18`,
            }}
          >
            {label}
          </span>
        );
      })}
    </div>
  );
}
